import React from 'react'
import CardSlider from '../FeedBack/CardSlider/CardSlider'
import styles from "./css/Expert.module.css"

export default function Expert() {
  return (
    <div className={styles.feedbackContainer}>
      <div style={{width:"90%"}}>
        <h3 className={styles.heading}>Our Experts</h3>
      
        </div>

      <CardSlider/>
    </div>
  )
}
